import ApplicantWatcher from './ApplicantWatcher'

export default ApplicantWatcher
